export default {
  activeMapButton: "",
  targetId: "initial",
  componentId: "R-luokka",
  streetview: "",
  portletId: "",
  time: "",
  // ui controls
  wideAsidePanel: false,
  componentSelectionDropdownOpen: false,
  escClicked: false,
  zoomState: 1.0
};
